import React from 'react';
import './AffiliatePage.css'; // Import custom CSS for this page
// We might need Link for internal navigation, but the main CTA is external
// import { Link } from 'react-router-dom';

const AffiliatePage = () => {
  return (
    <main className="affiliate-landing-page"> {/* New top-level class for specific styling */}
      {/* Hero Section */}
      <section className="hero-section affiliate-hero text-center py-5">
        <div className="container">
          {/* Optional: Image/Graphic for Hero */}
          {/* <img src="https://via.placeholder.com/400x300.png?text=Affiliate+Program+Visual" alt="GTO Preflop Affiliate Program" className="hero-main-image mb-4" /> */}
          <h1 className="display-4 fw-bold">
            Partner with GTO Preflop & <span className="highlight-text">earn comission on every referral.</span>
          </h1>
          <p className="lead my-4">
            Join our affiliate program and leverage a <span className="highlight-text">trusted brand</span> to turn your audience into revenue. 
            <strong> Generous commissions</strong> and a <span className="highlight-text">beloved product</span> await!
          </p>
          <a
            href="https://affiliate.gtopre.com"
            className="btn btn-primary btn-lg cta-button" // Added btn, btn-primary, btn-lg for bootstrap like styling
            target="_blank"
            rel="noopener noreferrer"
          >
            Become a GTO Preflop Affiliate Today!
          </a>
        </div>
      </section>

      {/* Why Partner With Us Section */}
      <section id="why-partner" className="py-5">
        <div className="container">
          <h2 className="text-center mb-5">Why Partner With <span className="highlight-text">GTO Preflop</span>?</h2>
          <div className="row">
            <div className="col-md-4 mb-4">
              <div className="card h-100 text-center">
                <img src="/img/feature_icons/stats.png" alt="Strong Brand" className="card-icon" loading="lazy" />
                <div className="card-body">
                  <h5 className="card-title">Strong, <span className="highlight-text">Loved Brand</span></h5>
                  <p className="card-text">GTO Preflop is a leading poker strategy app with a <strong>dedicated user base</strong> that trusts and loves our product.</p>
                </div>
              </div>
            </div>
            <div className="col-md-4 mb-4">
              <div className="card h-100 text-center">
                <img src="/img/feature_icons/advanced.png" alt="Generous Revenue" className="card-icon" loading="lazy" />
                <div className="card-body">
                  <h5 className="card-title">Generous <span className="highlight-text">Revenue Share</span></h5>
                  <p className="card-text">We offer a <strong>competitive revenue share model</strong> designed to maximize your earnings. Our commission rates are <span className="highlight-text">above the industry norm</span>.</p>
                </div>
              </div>
            </div>
            <div className="col-md-4 mb-4">
              <div className="card h-100 text-center">
                <img src="/img/feature_icons/fast_ranges.png" alt="High Conversion" className="card-icon" loading="lazy" />
                <div className="card-body">
                  <h5 className="card-title">High <span className="highlight-text">Conversion Rates</span></h5>
                  <p className="card-text">With a quality product and <strong>strong brand reputation</strong>, your referrals are more likely to convert, meaning <strong>more commissions</strong> for you.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Who Is This For Section */}
      <section id="who-for" className="py-5 bg-light">
        <div className="container">
          <h2 className="text-center mb-5">Who Is Our Affiliate Program <span className="highlight-text">For</span>?</h2>
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <p className="lead text-center mb-4">
                If you have an audience interested in <span className="highlight-text">poker</span>, poker strategy, or <span className="highlight-text">improving their game</span>, our affiliate program is a perfect fit. This includes:
              </p>
              {/* Optional: Image for this section */}
              {/* <img src="https://via.placeholder.com/600x200.png?text=Audience+Types" alt="Diverse Poker Audience" className="section-image mb-4" /> */}
              <ul className="list-group list-group-flush">
                <li className="list-group-item"><strong>Poker Content Creators</strong> (YouTubers, Twitch Streamers)</li>
                <li className="list-group-item"><strong>Bloggers & Writers</strong> with a Poker Niche</li>
                <li className="list-group-item"><strong>Newsletter Operators</strong></li>
                <li className="list-group-item"><strong>Poker Influencers & Coaches</strong></li>
                <li className="list-group-item"><strong>Forum Owners & Community Managers</strong></li>
                <li className="list-group-item">Anyone with an audience, <strong>big or small</strong>, passionate about poker!</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section id="how-it-works" className="py-5">
        <div className="container">
          <h2 className="text-center mb-5">How It <span className="highlight-text">Works</span></h2>
          <div className="row text-center">
            <div className="col-md-4 mb-4 process-step">
              <div className="step-circle">
                <span>1</span>
              </div>
              <h5><span className="highlight-text">Sign Up</span></h5>
              <p>Join our affiliate program <strong>quickly and easily</strong> through our dedicated affiliate portal.</p>
            </div>
            <div className="col-md-4 mb-4 process-step">
              <div className="step-circle">
                <span>2</span>
              </div>
              <h5><span className="highlight-text">Promote</span></h5>
              <p>Share your <strong>unique promo code</strong> and our marketing materials on your platform(s).</p>
            </div>
            <div className="col-md-4 mb-4 process-step">
              <div className="step-circle">
                <span>3</span>
              </div>
              <h5><span className="highlight-text">Earn</span></h5>
              <p>Earn <strong>competitive commissions</strong> for every new customer you refer. Track your success in real-time.</p>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section id="faq" className="py-5 bg-light">
        <div className="container">
          <h2 className="text-center mb-5">Frequently Asked <span className="highlight-text">Questions</span></h2>
          <div className="accordion" id="faqAccordion">
            {/* FAQ Item 1 */}
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingOne">
                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                  What are the commission rates?
                </button>
              </h2>
              <div id="collapseOne" className="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#faqAccordion">
                <div className="accordion-body">
                  We offer a <strong>highly competitive</strong> commission structure. Specific details are provided upon signup to our affiliate portal, but rest assured, our rates are designed to be <span className="highlight-text">very attractive</span>.
                </div>
              </div>
            </div>
            {/* FAQ Item 2 */}
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingTwo">
                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                  How and when do I get paid?
                </button>
              </h2>
              <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#faqAccordion">
                <div className="accordion-body">
                  Payments are typically made on a <strong>monthly basis</strong> through our affiliate platform. You can choose your preferred payment method during setup. More details are available in the affiliate dashboard.
                </div>
              </div>
            </div>
            {/* FAQ Item 3 */}
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingThree">
                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                  What marketing materials do you provide?
                </button>
              </h2>
              <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#faqAccordion">
                <div className="accordion-body">
                  We provide a range of marketing assets, including <strong>banners, logos, and promotional text</strong> to help you succeed. You'll find these in the affiliate portal.
                </div>
              </div>
            </div>
            {/* FAQ Item 4 */}
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingFour">
                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                  Do I need technical knowledge to join?
                </button>
              </h2>
              <div id="collapseFour" className="accordion-collapse collapse" aria-labelledby="headingFour" data-bs-parent="#faqAccordion">
                <div className="accordion-body">
                  <strong>Not at all!</strong> Our affiliate system is user-friendly and designed to be accessible to everyone. You simply share your unique link with your audience.
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Final Call to Action Section */}
      <section id="final-cta" className="py-5 text-center">
        <div className="container">
          <h2>Ready to <span className="highlight-text">Start Earning</span>?</h2>
          <p className="lead my-4">
            Join the GTO Preflop affiliate family today and turn your <span className="highlight-text">passion for poker</span> into <strong>profit</strong>.
          </p>
          <a
            href="https://affiliate.gtopre.com"
            className="btn btn-primary btn-lg cta-button" // Added btn, btn-primary, btn-lg for bootstrap like styling
            target="_blank"
            rel="noopener noreferrer"
          >
            Sign Up for the Affiliate Program Now!
          </a>
        </div>
      </section>
    </main>
  );
};

export default AffiliatePage; 